import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ILicenseSearchResult } from '../../Licenses/store/types';

import { type IRestriction, type ISortConfig, type IStateData } from '../../../types';
import { DEFAULT_PAGE_SIZE, SortDirection } from '../../../constants';
import { type SearchResult } from '../../../@types/serviceTypes';

import { SearchSelectField } from '../configs';

const initialState: IStateData<ILicenseSearchResult> & { search: Record<string, IRestriction> } = {
  data: [],
  isLoading: false,
  totalCount: 0,
  search: {},
  pagination: {
    size: DEFAULT_PAGE_SIZE,
    currentPage: 1,
  },
  sortConfig: {
    field: SearchSelectField.licenseType,
    mode: SortDirection.DESC,
  },
};

const childrenSlice = createSlice({
  name: 'children',
  initialState,
  reducers: {
    setChildren: (state, { payload }: PayloadAction<SearchResult<ILicenseSearchResult>>) => {
      state.data = payload.resultList;
      state.totalCount = payload.totalCount;
    },
    setChildrenLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    resetChildren: () => initialState,
    setChildrenCurrentPage: (state, { payload }: PayloadAction<number>) => {
      state.pagination.currentPage = payload;
    },
    setChildrenSearch: (state, { payload }: PayloadAction<Record<string, IRestriction>>) => {
      state.search = payload;
    },
    setChildrenSortConfig: (state, { payload }: PayloadAction<ISortConfig<ILicenseSearchResult>>) => {
      state.sortConfig = payload;
    },
  },
});

export const {
  setChildren,
  setChildrenLoading,
  resetChildren,
  setChildrenCurrentPage,
  setChildrenSearch,
  setChildrenSortConfig,
} = childrenSlice.actions;

export default childrenSlice;
